/* eslint-disable jsx-a11y/anchor-has-content */
import React, { } from "react";
import "./footer.scss";
import Container from "../container/container";

interface Props {
}

const Footer: React.FC<Props> = () => {

  return (
    <>
      <section className="footer">
        <Container>
          <div className="left">Czas na design &copy; 2021</div>
          <div className="center"><a href="https://ideeas.pl">
            Realizacja: ideeas
          </a></div>
        </Container>
      </section>
    </>
  )
}

export default Footer;